export default __webpack_public_path__ + "media/icons/check-circle-green-ee3b4456.svg";